import template from './has-shop-windows.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
  .module('cian.addForm.aboutObjectHasShopWindows', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectHasShopWindows', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsHasNo;
    },
    controllerAs: 'hasShopWindows',
    template,
  })).name;
